import { useEffect } from 'react';
import { NativeFunctions } from '../core/util/native';

export default (color: any) => {
  useEffect(() => {
    NativeFunctions.setSafeAreaColor.call(color);
  }, [color]);
};
